'use client'

import { useQueryResults } from "@/hooks/useQueryResults";
import { useMemo } from "react";
import { BarChart, ChartSeries, ChartDataPoint } from "./charts/bar-chart";
import moment from "moment";

export function MeaningfulWallets() {
    const { results } = useQueryResults({id: 6449096})

    const formattedData = useMemo(() => {
        if (!results) return []
        let months = [... new Set(results.map(r => r.month))]
        let seriesData = results.reduce((acc, el) => {
            let seriesName = `${el.token}.${el.chain}`
            if (!acc[seriesName]) {
                acc[seriesName] = [{
                    x: el.date.format('YYYY-MM-DD'),
                    y: el.users as number
                }]
            } else {
                acc[seriesName].push({
                    x: el.date.format('YYYY-MM-DD'),
                    y: el.users as number
                })
            }
            
            return acc
        }, {} as Record<string, ChartDataPoint[]>)

        const kk = Object.keys(seriesData).sort().map(k => ({id: k, data: seriesData[k]}))
        return kk
    }, [results])

    // return <BarChart data={formattedData}/>
    return <div className="w-full h-[40vh]">
        <BarChart
            data={formattedData}
            description="Amount of wallets that hold 10 or more tokens at the month's end"
            title="Sky Ecosystem: Meaningful Wallets"
            showTotal
            tooltip={{
                xAxisFormatter: (v) => moment.utc(v).format("MMM YYYY")
            }}
        />
    </div>
}